import { AcademicLeague } from "../types/battle"

export type ProfileFrameKey =
  | "titan_frame"
  | "atlant_frame"
  | "titan_chest_frame"
  | "atlant_chest_frame"

export type ProfileFrameRenderMode =
  | "default"
  | "ring"
  | "hybrid"
  | "overlay"
  | "animated"

export const PROFILE_FRAME_KEYS: Array<ProfileFrameKey | null> = [
  null,
  "titan_frame",
  "atlant_frame",
  "titan_chest_frame",
  "atlant_chest_frame",
]

export const PROFILE_FRAME_LABELS: Record<ProfileFrameKey, string> = {
  titan_frame: "Рамка Титанов",
  atlant_frame: "Рамка Атлантов",
  titan_chest_frame: "Рамка с сундуком (Титаны)",
  atlant_chest_frame: "Рамка с сундуком (Атланты)",
}

export const PROFILE_FRAME_RENDER_MODE_LABELS: Record<
  ProfileFrameRenderMode,
  string
> = {
  default: "Дефолт (без рамки)",
  ring: "B — программное кольцо",
  hybrid: "C — кольцо + декор",
  overlay: "A — PNG overlay",
  animated: "D — пульс glow (chest)",
}

/** Минимальный guardian rank для ободка стихии (*Round.png). */
export const ELEMENT_RANK_FRAME_MIN_GUARDIAN_RANK = 5

export interface ResolvedProfileFrame {
  key: ProfileFrameKey
  label: string
  league: AcademicLeague
  accent: string
  isChest: boolean
}

export function isProfileFrameKey(key: string): key is ProfileFrameKey {
  return (
    key === "titan_frame" ||
    key === "atlant_frame" ||
    key === "titan_chest_frame" ||
    key === "atlant_chest_frame"
  )
}

export function resolveProfileFrame(
  key: string | null | undefined
): ResolvedProfileFrame | null {
  if (!key || !isProfileFrameKey(key)) return null
  const league: AcademicLeague = key.startsWith("titan") ? "TITAN" : "ATLANT"
  return {
    key,
    label: PROFILE_FRAME_LABELS[key],
    league,
    accent: league === "TITAN" ? "#FACC15" : "#38BDF8",
    isChest: key.endsWith("_chest_frame"),
  }
}

/** Продакшн-режим: любая рамка → animated, иначе default. */
export function resolveProfileFrameRenderMode(
  key: string | null | undefined
): ProfileFrameRenderMode {
  const frame = resolveProfileFrame(key)
  if (!frame) return "default"
  return "animated"
}
